import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-6 md:py-8 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center">
          <Link to="/" className="text-lg md:text-xl font-bold text-[#8d2424] mb-4 text-center hover:text-[#7a1e1e] transition-colors no-underline">
            LiveWire Product Search Database
          </Link>
          <div className="flex space-x-4 mb-4">
            <a
              href="https://facebook.com/livewiremusicnow"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-[#8d2424] transition-colors"
            >
              <FaFacebook className="text-xl md:text-2xl" />
            </a>
            <a
              href="https://instagram.com/livewiremusicnow"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-[#8d2424] transition-colors"
            >
              <FaInstagram className="text-xl md:text-2xl" />
            </a>
          </div>
          <p className="text-xs md:text-sm text-gray-600 text-center">
            © {currentYear} LiveWire Music - All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;